import React, { useEffect, useState } from 'react';
import { APIAbonos } from "../../../../services/api/facturas";


const ViewerAbono = ({ abonoId }) => {
  const [fileUrl, setFileUrl] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = await APIAbonos.viewAbono(abonoId);
        setFileUrl(url);
      } catch (error) {
        console.error('Error al obtener el documento del abono:', error);
        // Manejar el error según tus necesidades
      }
    };

    fetchData();
  }, [abonoId]);

  if (!fileUrl) {
    return <p>Cargando...</p>;
  }

  return (
    <div>
      <iframe
        title="Abono PDF"
        width="100%"
        height="600"
        src={fileUrl}
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default ViewerAbono;
